import React, { useMemo } from 'react';
import { ReactComponent as StopMarker } from './stop-marker.svg';

const images = {
  StopMarker,
};

const Image = ({ type, color, strokeColor, onClick, weatherData }) => {
  const { time, degree, iconUrl } = weatherData || {};
  const SVG = useMemo(() => {
    const SVGComponent = images[type];
    return SVGComponent ? (
      <SVGComponent style={{ fill: color || undefined, stroke: strokeColor || undefined }} />
    ) : null;
  }, [type, color, strokeColor]);

  return (
    <div className={`img-${type}`} onClick={onClick}>
      {SVG}
      {weatherData && (
        <div className="weather-info">
          <p>
            {time} {weatherData.dayDiff ? `+${weatherData.dayDiff}` : ''}
          </p>
          <p className="degree">{Math.round(degree)}º</p>
          <img className="weather-icon" src={iconUrl} alt={''} />
        </div>
      )}
    </div>
  );
};

export default React.memo(Image);
